export default {
  methods: {
    /**
     * @param {object} input
     * @param {string} sourceText
     * @param {string} addiction
     * @param {function} setter
     * @return {string}
     */
    addTextInCursorPosition(input, sourceText, addiction, setter) {
      if (!_.hasIn(input, 'selectionStart') || !_.hasIn(input, 'selectionEnd')) {
        setter(sourceText + addiction);
      }

      const start = _.get(input, 'selectionStart', 0);
      const end = _.get(input, 'selectionEnd', 0);
      const nextPosition = end + addiction.length;

      setter([sourceText.slice(0, start), addiction, sourceText.slice(end)].join(''));

      if (_.isFunction(input.setSelectionRange)) {
        this.$nextTick(function () {
          input.setSelectionRange(nextPosition, nextPosition);
        });
      }
    },
  }
}
